import React from 'react';

import { ColumnConfig, ColumnConfigProps } from '@bringg-frontend/monitoring-shared';

import { useStores } from 'bringg-web/recipes';
import { hasFeatureFlag } from 'bringg-web/utils/feature-flags';

import styles from './details-nav-ber.module.scss';

interface Props {
	columnsConfigProps: ColumnConfigProps;
}

const DetailsNavBar = ({ columnsConfigProps }: Props) => {
	const {
		usersStore: { currentUser }
	} = useStores();
	const columnConfigEnabled = hasFeatureFlag(currentUser, 'routes_monitoring_columns_config_enabled');

	return (
		<div className={styles.detailsNavBar}>{columnConfigEnabled && <ColumnConfig {...columnsConfigProps} />}</div>
	);
};

export default DetailsNavBar;
